<div style="padding: 0px;">
    <div class="fixedTitle">
        <div class="col-md-12 col-lg-12 col-12" style="padding: 15px; padding-bottom: 0px;">
            <div class="col-md-11 col-lg-11 col-11" style="padding: 0px; display: inline-block;">
                <span class="mobView" style="font-size: 22px; margin-right: 10px; display: inline-block;" (click)="back()"><i class="fa fa-chevron-left"></i></span>
                <h4 style="display: inline-block; color: #555;">{{prTypeID == 1 ? 'Select Items' : 'Select Project Type'}}</h4>
                <!-- <h4 style="padding-right: 15px; display: inline-block;font-size: 1.5rem; top: 14px !important;">{{!isFromProjectMod ? 'Select Items' : 'Select Item'}}</h4> -->

            </div>
            <div class="col-md-1 col-lg-1 col-1" style="padding: 0px; display: inline-block; text-align: right;">
                <i class="closeMdl zmdi zmdi-close webView" style="position: relative; bottom: 10px; margin-top: 0px; padding: 8px 14px !important;" (click)="closeModal()"></i>
            </div>
        </div>
        <div style="padding-left: 15px; padding-right: 15px;">
            <div *ngIf="ft == 1" class="yellowBadge" style="display: inline-block; margin-top: 5px; margin-bottom: 5px; cursor: pointer; display: none;">
                <div style="display: inline-block;" (click)="selectStore(storeSelect)"><i class="zmdi zmdi-city-alt" style="margin-right: 5px; font-size: 17px;"></i>  {{store.id == -1 ? 'Select Store' : ((store.id > 0) && (typeID == 4 || typeID == 5)) ? 'To' : 'From' }} {{store.name}} <i class="fa fa-pencil" *ngIf="stc" style="margin-left: 5px; font-size: 12px;"></i></div>
            </div>
            <div *ngIf="ft == 1" class="" style="display: inline-block; margin-top: 5px; margin-bottom: 5px; cursor: pointer;">
                <div style="display: inline-block; font-size: 13px;">
                    Select Store :
                </div>
                <div style="display: inline-block;">
                    <select class="label Bluebadge form-control bzInput" style="width: 250px !important; margin-left: 10px !important; font-size: 13px; padding: 3px;" [(ngModel)]="store.id" (ngModelChange)="selectStoreDropdown()" [disabled]="!stc">
                        <option value="-1" selected>Select</option>
                        <option *ngFor="let s of stores" [ngValue]="s.StrID">{{s.sNm}}</option> 
                    </select>
                </div>
            </div>
            
            <div class="col-md-12 col-lg-12 col-12" style="display: inline-block; width: 100%; margin-top: 10px; padding: 0px;">
                <div class="input-icons search">
                    <span class="fa fa-search" style="color: #999; font-size: 13px; margin-left: -2px; margin-top: -3px"></span>
                    <input class="form-control searchBar brdrRadius3 bzInput" [(ngModel)]="search" placeholder="Search" style="padding-left: 35px !important; padding: 16px; box-shadow: none !important; width: 100%; background-color: #fff !important;" type="text">
                </div>
            </div>
            <div class="greenBadge" style="display: inline-block; margin-top: 5px; padding: 0px 15px 0px 15px; line-height: 40px; display: none;" *ngIf="selectedItemCount > 0">
                {{selectedItemCount}} item selected
            </div>
        </div>
    </div>
    
    <div class="modal-body itemList">       
        <div *ngIf="prTypeID != 2" class="col-md-12 col-lg-12 col-12" style="padding: 15px; padding-right: 5px;">
            <div class="col-md-12 col-lg-12 col-12 dtlCard" *ngFor="let a of items | filter:'ItemName,ItemCode,CN,SC':search" (click)="selectItem(a)" >
                <!-- Name & Qty -->
                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="display: flex; align-items: flex-start;">
                    <!-- Name and Item Code -->
                    <div class="col-md-8 col-lg-8 col-8 col-xs-8 pad0 inLneBlk" style="flex-grow: 1; padding: 0;">
                        <div style="display: flex; align-items: flex-start;">
                            <div style="flex-shrink: 0; margin-right: 5px;">
                                <input class="chkbox-darkblue" type="checkbox" id="item" name="item" [(ngModel)]="a.isSelected" (ngModelChange)="getSelectedItemCount()" 
                                style="height: 14px !important; width: 15px !important; cursor: pointer !important;">
                            </div>
                            <div style="flex-grow: 1; overflow: hidden;">
                                <span style="display: block; font-weight: bold; color: #444444; font-size: 14px; word-break: break-word; padding-bottom: 5px; line-height: 15px; margin-top: 3px;">{{a.ItemName}}</span>
                                <div style="font-size: 12px; color: grey; margin-bottom: 0px; font-weight: 550; line-height: 13px;">
                                    # {{a.ItemCode}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- qty -->
                    <div class="col-md-4 col-lg-4 col-4" style="flex-shrink: 0; display: flex; align-items: center; justify-content: flex-end; padding: 0;">
                        <div class="dtlBadge darkGreen brdrRadius3 bgwhite" style="padding: 3px 10px !important; font-size: 12px; color: #4caf50; border: 1px solid #4caf50; border-radius: 3px; margin-right: 0px; margin-top: 3px;">
                            {{a.StoreBatches.length > 0 ? a.StoreItemQty : a.CurrQty}} {{a.SKU}}
                        </div>
                    </div> 
                </div>
    
                <!-- code -->
                <div class="col-md-12 col-lg-12 col-12" 
                style="display: inline-block; padding: 0px;">
                    <!-- <div class="dtlBadge darkBlue" style="padding: 3px 10px;" title="Item Code">
                        # {{a.ItemCode}}
                    </div> -->
                    <div style="font-size: 12px; color: grey; margin-bottom: 7px; margin-left: 20px; line-height: 13px; padding-top: 7px;" *ngIf="a.CN" >
                        {{a.CN}} / {{a.SC}}
                    </div>
                    <!-- <div class="dtlBadge darkBlue" style="padding: 3px 10px ;" *ngIf="a.SC">
                        {{a.SC}}
                    </div> -->
                </div> 
            </div>
        </div>

        <div *ngIf="prTypeID == 2" class="col-md-12 col-lg-12 col-12" style="padding: 15px; padding-right: 5px;">
            <div  class="col-md-12 col-lg-12 col-12 dtlCard" *ngFor="let a of items | filter:'ItemName,ItemCode':search" (click)="selectItem(a)">
                <div class="col-md-8 col-lg-8 col-8 col-xs-8 pad0 inLneBlk" style="flex-grow: 1; padding: 0;">
                    <div style="display: flex; align-items: flex-start;">
                        <div style="flex-shrink: 0; margin-right: 5px;">
                            <input class="chkbox-darkblue" type="checkbox" id="item" name="item" [(ngModel)]="a.isSelected" (ngModelChange)="getSelectedItemCount()" 
                            style="height: 14px !important; width: 15px !important; cursor: pointer !important;">
                        </div>
                        <div style="flex-grow: 1; overflow: hidden;">
                            <span style="display: block; font-weight: bold; color: #444444; font-size: 14px; word-break: break-word; padding-bottom: 5px; line-height: 15px; margin-top: 3px;">{{a.ItemName}}</span>
                            <div style="font-size: 12px; color: grey; margin-bottom: 0px; font-weight: 550; line-height: 13px;">
                                # {{a.ItemCode}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-md-12 col-lg-12 col-12" *ngIf="items.length === 0">
            <div class="nrf brdrRadius3">{{ firstTime ? (prTypeID == 2 ? 'Please add Project type.': 'Please select store.') : 'No Items found.'}}</div>
        </div>
        
    </div>
    
    <div class="wid500 bottom selectFooter" style="position: sticky; bottom: 20px; text-align: center;">
        <div class="darkBlueButton brdrRadius3" (click)="select()" style="padding: 0px 15px !important; line-height: 30px; font-size: 14px; margin-right: 10px;"> <i class="fa fa-check" style="margin-left: -5px; margin-right: 3px" aria-hidden="true"></i> Select <span *ngIf="selectedItemCount > 0 && prTypeID == 1">({{selectedItemCount}} {{selectedItemCount == 1 ? 'item' : 'items'}})</span></div>
        <div style="background-color: #F8F8F8; display: inline-block;">
            <div class="btn-mdlClose brdrRadius3" (click)="goBack();" style = "line-height: 20px;">
                <i class="fa fa-close"></i> Close
            </div>
        </div>
    </div>
</div>

<!-- Store Selection Modal -->
<ng-template #storeSelect let-modal>
    <app-select-store></app-select-store>
</ng-template>


